import {Button, Drawer, Grid} from '@material-ui/core';
import 'Agent/Claims/components/ChecksDrawer.sass';
import ChecksIssuedSummary from 'Agent/Claims/components/ChecksIssuedSummary';
import {toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';

type ChecksDrawerProps = {
  claimNumber: string;
  open: boolean;
  onClose: () => void;
};

const ChecksDrawer = (props: ChecksDrawerProps) => {
  const {open, onClose, claimNumber} = props;
  const {checks} = useSelector((state: ReducerState) => state.claim);

  const checkContents = pipe(
    checks,
    toEither,
    E.fold(renderAsync, checks => <ChecksIssuedSummary claimNumber={claimNumber} checks={checks} />)
  );

  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <div className="checks-list">
        <Grid container direction="column" wrap="nowrap">
          {checkContents}
        </Grid>
        <Button color="primary" className="checks-list__close-button" onClick={onClose}>
          Close
        </Button>
      </div>
    </Drawer>
  );
};

export default ChecksDrawer;
